import App from '@/App.vue';
import router from './router';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Quasar } from 'quasar';
import { quasarConfig } from './quasar-user-options';
import 'quasar/src/css/index.sass';

import accessConstants from '@/plugins/accessConstants';
import { VueLogger, options } from '@/plugins/vueLogger';
import { i18n } from '@/plugins/i18n';
import { amplifyConfiguration } from '@/plugins/amplify';
import { Amplify } from 'aws-amplify';
import { version } from '../package.json';

import 'amazon-connect-streams';
import 'amazon-connect-chatjs';

// Set dynamic page title
document.title = `Poste CCP v.${version}`;

Amplify.configure(amplifyConfiguration);

import Button from '@/components/shared/atoms/Button.vue';
import Icon from '@/components/shared/atoms/Icon.vue';
import TextField from '@/components/shared/atoms/TextField.vue';
import ToastMessage from '@/components/shared/atoms/ToastMessage.vue';
import Card from '@/components/shared/molecules/Card.vue';
import HorizontalCard from '@/components/shared/molecules/HorizontalCard.vue';
import Dialog from '@/components/shared/organisms/Dialog.vue';
import Table from '@/components/shared/organisms/Table.vue';

import '@/styles/main.css';
import '@/styles/tailwind.sass';

const app = createApp(App)
  .use(createPinia())
  .use(Quasar, quasarConfig)
  .use(router)
  .use(accessConstants)
  .use(VueLogger, options)
  .use(i18n)
  .component('Button', Button)
  .component('Icon', Icon)
  .component('TextField', TextField)
  .component('ToastMessage', ToastMessage)
  .component('Card', Card)
  .component('HorizontalCard', HorizontalCard)
  .component('Dialog', Dialog)
  .component('Table', Table)
  .mount('#app');

const $log = app.$log;
const t = app.$t;

export {
  $log,
  t
};